const TILE_PREFIX_FALLBACK = "tile";
const TILE_PREFIX_MAX_LENGTH = 20;

export function toRowColumn(index, tilesWide) {
    const row = Math.floor(index / tilesWide);
    const column = index % tilesWide;
    return { row, column };
}

function hashLabel(value, hashLength = 4) {
    let hash = 5381;

    for (let index = 0; index < value.length; index++) {
        hash = ((hash << 5) + hash + value.charCodeAt(index)) >>> 0;
    }

    return hash.toString(36).padStart(hashLength, "0").slice(0, hashLength);
}

function sanitizePrefix(label) {
    const noExtension = label.replace(/\.[^.]+$/, "");
    const normalized = noExtension
        .toLowerCase()
        .replace(/[^a-z0-9-]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

    return normalized || TILE_PREFIX_FALLBACK;
}

export function buildTilePrefix(sourceFileName, maxLength = TILE_PREFIX_MAX_LENGTH) {
    const sanitized = sanitizePrefix(sourceFileName ?? "");

    if (sanitized.length <= maxLength) {
        return sanitized;
    }

    const suffix = hashLabel(sanitized);
    const headLength = Math.max(1, maxLength - suffix.length - 1);
    return `${sanitized.slice(0, headLength)}-${suffix}`;
}

export function makeTileName(row, column, extension = "png", prefix = TILE_PREFIX_FALLBACK) {
    const rowLabel = String(row + 1).padStart(2, "0");
    const columnLabel = String(column + 1).padStart(2, "0");
    return `${prefix}_r${rowLabel}_c${columnLabel}.${extension}`;
}

export function buildTileManifest(tilesWide, tilesHigh, extension = "png", prefix = TILE_PREFIX_FALLBACK) {
    const manifest = [];
    const total = tilesWide * tilesHigh;

    for (let index = 0; index < total; index++) {
        const { row, column } = toRowColumn(index, tilesWide);
        manifest.push({
            index,
            row,
            column,
            fileName: makeTileName(row, column, extension, prefix)
        });
    }

    return manifest;
}
